import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControls: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGamepadControls"><Path d="M16 2H8V7.06066L12 11.0607L16 7.06066V2Z" fill="currentColor"/><Path d="M22 8H16.9393L12.9393 12L16.9393 16H22V8Z" fill="currentColor"/><Path d="M16 22V16.9393L12 12.9393L8 16.9393V22H16Z" fill="currentColor"/><Path d="M2 8V16H7.06066L11.0607 12L7.06066 8H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControls;
